import { authHeader } from "../util/auth-header";
import http from "../util/http-common";

export class MakeService {
  static async getAll() {
    return http.get("/cfadminsysmaintain/api/v1/makes",{ headers: await authHeader()});
  }

  static async create(data: any) {
    return http.post("/cfadminsysmaintain/api/v1/makes", data, { headers: await authHeader()});
  }

  static async update(id: number, data: any) { //id to pass
    return http.put(`/cfadminsysmaintain/api/v1/makes/${id}`, data, { headers: await authHeader()});
  }

  static async delete(id: any) {
    return http.delete(`/cfadminsysmaintain/api/v1/makes/${id}`,{ headers: await authHeader()});
  }

}

export default MakeService;